import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { ConfirmDialog } from "@outpave/ds";

interface Props {
  /** Stages the defaults; the page's Save commits them. */
  onReset: () => void;
  disabled?: boolean;
  /** What this surface resets, and what it keeps. */
  message: string;
}

/** Reset reaches tabs the admin is not looking at, so it says what it covers first. */
const ResetBrandingButton: React.FC<Props> = ({
  onReset,
  disabled,
  message,
}) => {
  const { t } = useTranslation();
  const [confirming, setConfirming] = useState(false);

  return (
    <>
      <Button
        variant="primary-outlined"
        disabled={disabled}
        onClick={() => setConfirming(true)}
      >
        {t("Reset")}
      </Button>
      <ConfirmDialog
        open={confirming}
        tone="primary"
        title={t("ResetBrandingTitle")}
        message={message}
        confirmLabel={t("Reset")}
        cancelLabel={t("Cancel")}
        onConfirm={() => {
          onReset();
          setConfirming(false);
        }}
        onCancel={() => setConfirming(false)}
      />
    </>
  );
};

export default ResetBrandingButton;
